import script from "./EditCounterAllowanceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCounterAllowanceModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditCounterAllowanceModal.vue?vue&type=style&index=0&id=0aa89fce&scoped=true&lang=css"
script.__scopeId = "data-v-0aa89fce"

export default script